module.exports = __webpack_public_path__ + "img/menu-button-1.cf9de15f.svg";